export default "__VITE_ASSET__B7_qMIkI__"